import * as React from "react";
import { Stage, Layer, Line as KonvaLine } from "react-konva";
import * as types from "../types";
import Seat from "./Seat";

import useManageStage from "../hooks/useManageStage";
import LabelComponent from "./TextLabels";
import useImage from "use-image";
import LineComponent from "./Line";
import { Context } from './Context'

interface Props {
  selectSeat: (id: number, seat: types.Seat) => void;
  unselectSeat: (id: number) => void;
  isSeatSelected: (id: number) => boolean;
  spectacleId: number;
  seatSelectorElementRef: any;
  seats: types.Seat[];
  lines: types.Line[];
  labels: types.Label[];
  spectacle: types.Spectacle;
  areaPrices: any;
  vatPrices: any;
  xMax: number;
  yMax: number;
  xMin: number;
  yMin: number;
  setHoverSeat: (seat: types.Seat | null) => void;
}

const SeatSelector: React.FC<Props> = ({
  selectSeat,
  unselectSeat,
  isSeatSelected,
  seats,
  lines,
  labels,
  xMax,
  yMax,
  xMin,
  yMin,
  spectacle,
  seatSelectorElementRef,
  setHoverSeat,
}) => {
  const { Height, Width } = spectacle;

  const [context, setContext] = React.useContext(Context);
  const [seatList, setSeatList] = React.useState(seats);
  React.useEffect(()=> {
    setContext(seats)
  }, [])

  React.useEffect(()=> {
    setSeatList(seats)
  }, [context])

  const {
    stageX,
    stageY,
    stageScale,
    handleButtonZoom,
    handleWheelZoom,
    resetZoom,
    stageRef,
    canvasHeight,
    canvasWidth,
    marginTopBottom,
    marginLeftRight,
  } = useManageStage(seatSelectorElementRef, Height, Width);

  const [freeSeatIcon] = useImage("/images/th-seat.png");
  const [selectedSeatIcon] = useImage("/images/th-seat-selected.png");
  const [reservedSeatIcon] = useImage("/images/th-seat-taken.png");

  return (
    <div className="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row mt-5">
      <div className="d-flex flex-md-column justify-content-center">
        <button
          type="button"
          className="btn btn-primary m-1 btnZoom"
          onClick={handleButtonZoom(100)}
        >
          +
        </button>

        <button
          type="button"
          className="btn btn-primary m-1 btnZoom"
          onClick={resetZoom}
        >
          0
        </button>
        <button
          type="button"
          className="btn btn-primary m-1 btnZoom"
          onClick={handleButtonZoom(-100)}
        >
          -
        </button>
      </div>
      <div>
        <Stage
          ref={stageRef}
          width={canvasWidth}
          height={canvasHeight}
          onWheel={handleWheelZoom}
          scaleX={stageScale}
          scaleY={stageScale}
          x={stageX}
          y={stageY}
          draggable={true}
          className="d-flex justify-content-center"
        >
          <Layer width={canvasWidth} height={canvasHeight}>
            {seatList.map((seat: types.Seat) => {
              return (
                <Seat
                  key={seat.SeatId}
                  data={seat}
                  selectSeat={selectSeat}
                  unselectSeat={unselectSeat}
                  isSelected={isSeatSelected(seat.SeatId)}
                  xMax={xMax}
                  yMax={yMax}
                  xMin={xMin}
                  yMin={yMin}
                  freeSeatIcon={freeSeatIcon}
                  reservedSeatIcon={reservedSeatIcon}
                  selectedSeatIcon={selectedSeatIcon}
                  canvasWidth={canvasWidth}
                  canvasHeight={canvasHeight}
                  marginTopBottom={marginTopBottom}
                  marginLeftRight={marginLeftRight}
                  setHoverSeat={setHoverSeat}
                />
              );
            })}

            {labels.map((label: types.Label) => {
              return (
                <LabelComponent
                  key={`${label.X}_${label.Y}`}
                  data={label}
                  xMax={xMax}
                  yMax={yMax}
                  xMin={xMin}
                  yMin={yMin}
                  canvasWidth={canvasWidth}
                  canvasHeight={canvasHeight}
                  marginTopBottom={marginTopBottom}
                  marginLeftRight={marginLeftRight}
                />
              );
            })}

            {lines.map((line: types.Line) => {
              return (
                <LineComponent
                  key={`${line.X1}_${line.X2}_${line.Y1}_${line.Y2}`}
                  data={line}
                  xMax={xMax}
                  yMax={yMax}
                  xMin={xMin}
                  yMin={yMin}
                  canvasWidth={canvasWidth}
                  canvasHeight={canvasHeight}
                  marginTopBottom={marginTopBottom}
                  marginLeftRight={marginLeftRight}
                />
              );
            })}
          </Layer>
        </Stage>
      </div>
    </div>
  );
};

export default SeatSelector;

/*

      <div>
        <button
          type="button"
          className="btn btn-primary m-1"
          onClick={handleButtonZoom(100)}
        >
          +
        </button>
        <button
          type="button"
          className="btn btn-primary m-1"
          onClick={handleButtonZoom(-100)}
        >
          -
        </button>
      </div>

*/
